/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import {
  BookingConfirmation,
  EmbedOrigins,
  LookupResult,
  PublicConfig,
  PublicHold,
  PublicOptions,
  SessionStarted,
  WeekAvailability,
} from './model'
import type {
  ApiError,
  BookingRequest,
  GetAvailabilityParams,
  HoldRequest,
  LookupRequest,
  PublicEventRequest,
  ReleaseHoldParams,
  StartSessionRequest,
} from './model'

import { apiFetch } from '../../fetcher.ts'
import type { ErrorType, BodyType } from '../../fetcher.ts'
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getGetAvailabilityUrl = (clinicSlug: string, params: GetAvailabilityParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/v1/public/clinics/${clinicSlug}/availability?${stringifiedParams}`
    : `/v1/public/clinics/${clinicSlug}/availability`
}

/**
 * @summary One week of open times for a location, visit type and provider (P-08)
 */
export const getAvailability = async (
  clinicSlug: string,
  params: GetAvailabilityParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<WeekAvailability> => {
  return apiFetch<WeekAvailability>(getGetAvailabilityUrl(clinicSlug, params), {
    ...options,
    method: 'GET',

    schema: WeekAvailability,
  })
}

export const getGetAvailabilityQueryKey = (clinicSlug: string, params?: GetAvailabilityParams) => {
  return [`/v1/public/clinics/${clinicSlug}/availability`, ...(params ? [params] : [])] as const
}

export const getGetAvailabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailability>>,
  TError = ErrorType<ApiError>,
>(
  clinicSlug: string,
  params: GetAvailabilityParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailability>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAvailabilityQueryKey(clinicSlug, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailability>>> = ({ signal }) =>
    getAvailability(clinicSlug, params, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicSlug !== null && clinicSlug !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAvailability>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailability>>>
export type GetAvailabilityQueryError = ErrorType<ApiError>

export function useGetAvailability<TData = Awaited<ReturnType<typeof getAvailability>>, TError = ErrorType<ApiError>>(
  clinicSlug: string,
  params: GetAvailabilityParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailability>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailability>>,
          TError,
          Awaited<ReturnType<typeof getAvailability>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailability<TData = Awaited<ReturnType<typeof getAvailability>>, TError = ErrorType<ApiError>>(
  clinicSlug: string,
  params: GetAvailabilityParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailability>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailability>>,
          TError,
          Awaited<ReturnType<typeof getAvailability>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAvailability<TData = Awaited<ReturnType<typeof getAvailability>>, TError = ErrorType<ApiError>>(
  clinicSlug: string,
  params: GetAvailabilityParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailability>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One week of open times for a location, visit type and provider (P-08)
 */

export function useGetAvailability<TData = Awaited<ReturnType<typeof getAvailability>>, TError = ErrorType<ApiError>>(
  clinicSlug: string,
  params: GetAvailabilityParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailability>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAvailabilityQueryOptions(clinicSlug, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getCreateBookingUrl = (clinicSlug: string) => {
  return `/v1/public/clinics/${clinicSlug}/bookings`
}

/**
 * @summary Book the held time in PF; requires Idempotency-Key (P-09 → P-10 → P-11 / P-12)
 */
export const createBooking = async (
  clinicSlug: string,
  bookingRequest?: BookingRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<BookingConfirmation> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<BookingConfirmation>(getCreateBookingUrl(clinicSlug), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bookingRequest),
    schema: BookingConfirmation,
  })
}

export const getCreateBookingMutationKey = () => ['createBooking'] as const

export const getCreateBookingMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBooking>>,
    TError,
    CreateBookingMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof createBooking>>, TError, CreateBookingMutationVariables, TContext> => {
  const mutationKey = getCreateBookingMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBooking>>, CreateBookingMutationVariables> = (
    props,
  ) => {
    const { clinicSlug, data } = props ?? {}

    return createBooking(clinicSlug, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateBookingMutationResult = NonNullable<Awaited<ReturnType<typeof createBooking>>>
export type CreateBookingMutationBody = BodyType<BookingRequest> | undefined
export type CreateBookingMutationError = ErrorType<ApiError>
export type CreateBookingMutationVariables = { clinicSlug: string; data?: BodyType<BookingRequest> }

/**
 * @summary Book the held time in PF; requires Idempotency-Key (P-09 → P-10 → P-11 / P-12)
 */
export const useCreateBooking = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBooking>>,
      TError,
      CreateBookingMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof createBooking>>, TError, CreateBookingMutationVariables, TContext> => {
  return useMutation(getCreateBookingMutationOptions(options), queryClient)
}

export const getGetPublicConfigUrl = (clinicSlug: string) => {
  return `/v1/public/clinics/${clinicSlug}/config`
}

/**
 * @summary Clinic name, contact, hours, booking status and reCAPTCHA site keys (P-00…P-06, P-14…P-17)
 */
export const getPublicConfig = async (
  clinicSlug: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<PublicConfig> => {
  return apiFetch<PublicConfig>(getGetPublicConfigUrl(clinicSlug), {
    ...options,
    method: 'GET',

    schema: PublicConfig,
  })
}

export const getGetPublicConfigQueryKey = (clinicSlug: string) => {
  return [`/v1/public/clinics/${clinicSlug}/config`] as const
}

export const getGetPublicConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicConfig>>,
  TError = ErrorType<ApiError>,
>(
  clinicSlug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicConfig>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPublicConfigQueryKey(clinicSlug)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicConfig>>> = ({ signal }) =>
    getPublicConfig(clinicSlug, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicSlug !== null && clinicSlug !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getPublicConfig>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetPublicConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicConfig>>>
export type GetPublicConfigQueryError = ErrorType<ApiError>

export function useGetPublicConfig<TData = Awaited<ReturnType<typeof getPublicConfig>>, TError = ErrorType<ApiError>>(
  clinicSlug: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicConfig>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicConfig>>,
          TError,
          Awaited<ReturnType<typeof getPublicConfig>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicConfig<TData = Awaited<ReturnType<typeof getPublicConfig>>, TError = ErrorType<ApiError>>(
  clinicSlug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicConfig>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicConfig>>,
          TError,
          Awaited<ReturnType<typeof getPublicConfig>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicConfig<TData = Awaited<ReturnType<typeof getPublicConfig>>, TError = ErrorType<ApiError>>(
  clinicSlug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicConfig>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Clinic name, contact, hours, booking status and reCAPTCHA site keys (P-00…P-06, P-14…P-17)
 */

export function useGetPublicConfig<TData = Awaited<ReturnType<typeof getPublicConfig>>, TError = ErrorType<ApiError>>(
  clinicSlug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicConfig>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPublicConfigQueryOptions(clinicSlug, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getRecordPublicEventUrl = (clinicSlug: string) => {
  return `/v1/public/clinics/${clinicSlug}/events`
}

/**
 * @summary Client-only funnel event: the P-01 choice (P-02 or P-03 / P-06 shown); always 204
 */
export const recordPublicEvent = async (
  clinicSlug: string,
  publicEventRequest?: PublicEventRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<void> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<void>(getRecordPublicEventUrl(clinicSlug), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(publicEventRequest),
  })
}

export const getRecordPublicEventMutationKey = () => ['recordPublicEvent'] as const

export const getRecordPublicEventMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordPublicEvent>>,
    TError,
    RecordPublicEventMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordPublicEvent>>,
  TError,
  RecordPublicEventMutationVariables,
  TContext
> => {
  const mutationKey = getRecordPublicEventMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordPublicEvent>>,
    RecordPublicEventMutationVariables
  > = (props) => {
    const { clinicSlug, data } = props ?? {}

    return recordPublicEvent(clinicSlug, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type RecordPublicEventMutationResult = NonNullable<Awaited<ReturnType<typeof recordPublicEvent>>>
export type RecordPublicEventMutationBody = BodyType<PublicEventRequest> | undefined
export type RecordPublicEventMutationError = ErrorType<ApiError>
export type RecordPublicEventMutationVariables = { clinicSlug: string; data?: BodyType<PublicEventRequest> }

/**
 * @summary Client-only funnel event: the P-01 choice (P-02 or P-03 / P-06 shown); always 204
 */
export const useRecordPublicEvent = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof recordPublicEvent>>,
      TError,
      RecordPublicEventMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof recordPublicEvent>>,
  TError,
  RecordPublicEventMutationVariables,
  TContext
> => {
  return useMutation(getRecordPublicEventMutationOptions(options), queryClient)
}

export const getPlaceHoldUrl = (clinicSlug: string) => {
  return `/v1/public/clinics/${clinicSlug}/holds`
}

/**
 * @summary Place a 5-minute hold; replaces any older hold of the visit or patient (P-08 → P-09)
 */
export const placeHold = async (
  clinicSlug: string,
  holdRequest?: HoldRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<PublicHold> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<PublicHold>(getPlaceHoldUrl(clinicSlug), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(holdRequest),
    schema: PublicHold,
  })
}

export const getPlaceHoldMutationKey = () => ['placeHold'] as const

export const getPlaceHoldMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof placeHold>>, TError, PlaceHoldMutationVariables, TContext>
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof placeHold>>, TError, PlaceHoldMutationVariables, TContext> => {
  const mutationKey = getPlaceHoldMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof placeHold>>, PlaceHoldMutationVariables> = (props) => {
    const { clinicSlug, data } = props ?? {}

    return placeHold(clinicSlug, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PlaceHoldMutationResult = NonNullable<Awaited<ReturnType<typeof placeHold>>>
export type PlaceHoldMutationBody = BodyType<HoldRequest> | undefined
export type PlaceHoldMutationError = ErrorType<ApiError>
export type PlaceHoldMutationVariables = { clinicSlug: string; data?: BodyType<HoldRequest> }

/**
 * @summary Place a 5-minute hold; replaces any older hold of the visit or patient (P-08 → P-09)
 */
export const usePlaceHold = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof placeHold>>, TError, PlaceHoldMutationVariables, TContext>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof placeHold>>, TError, PlaceHoldMutationVariables, TContext> => {
  return useMutation(getPlaceHoldMutationOptions(options), queryClient)
}

export const getReleaseHoldUrl = (clinicSlug: string, holdId: string, params?: ReleaseHoldParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/v1/public/clinics/${clinicSlug}/holds/${holdId}?${stringifiedParams}`
    : `/v1/public/clinics/${clinicSlug}/holds/${holdId}`
}

/**
 * @summary Release the visit's own hold; idempotent (P-09 Back/Change, expiry)
 */
export const releaseHold = async (
  clinicSlug: string,
  holdId: string,
  params?: ReleaseHoldParams,
  options?: Parameters<typeof apiFetch>[1],
): Promise<void> => {
  return apiFetch<void>(getReleaseHoldUrl(clinicSlug, holdId, params), {
    ...options,
    method: 'DELETE',
  })
}

export const getReleaseHoldMutationKey = () => ['releaseHold'] as const

export const getReleaseHoldMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof releaseHold>>, TError, ReleaseHoldMutationVariables, TContext>
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof releaseHold>>, TError, ReleaseHoldMutationVariables, TContext> => {
  const mutationKey = getReleaseHoldMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof releaseHold>>, ReleaseHoldMutationVariables> = (
    props,
  ) => {
    const { clinicSlug, holdId, params } = props ?? {}

    return releaseHold(clinicSlug, holdId, params, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ReleaseHoldMutationResult = NonNullable<Awaited<ReturnType<typeof releaseHold>>>

export type ReleaseHoldMutationError = ErrorType<ApiError>
export type ReleaseHoldMutationVariables = { clinicSlug: string; holdId: string; params?: ReleaseHoldParams }

/**
 * @summary Release the visit's own hold; idempotent (P-09 Back/Change, expiry)
 */
export const useReleaseHold = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof releaseHold>>,
      TError,
      ReleaseHoldMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof releaseHold>>, TError, ReleaseHoldMutationVariables, TContext> => {
  return useMutation(getReleaseHoldMutationOptions(options), queryClient)
}

export const getLookupPatientUrl = (clinicSlug: string) => {
  return `/v1/public/clinics/${clinicSlug}/lookup`
}

/**
 * @summary Find the patient in PF; a unique match starts the 15-minute patient session (P-03)
 */
export const lookupPatient = async (
  clinicSlug: string,
  lookupRequest?: LookupRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<LookupResult> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<LookupResult>(getLookupPatientUrl(clinicSlug), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(lookupRequest),
    schema: LookupResult,
  })
}

export const getLookupPatientMutationKey = () => ['lookupPatient'] as const

export const getLookupPatientMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lookupPatient>>,
    TError,
    LookupPatientMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof lookupPatient>>, TError, LookupPatientMutationVariables, TContext> => {
  const mutationKey = getLookupPatientMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof lookupPatient>>, LookupPatientMutationVariables> = (
    props,
  ) => {
    const { clinicSlug, data } = props ?? {}

    return lookupPatient(clinicSlug, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type LookupPatientMutationResult = NonNullable<Awaited<ReturnType<typeof lookupPatient>>>
export type LookupPatientMutationBody = BodyType<LookupRequest> | undefined
export type LookupPatientMutationError = ErrorType<ApiError>
export type LookupPatientMutationVariables = { clinicSlug: string; data?: BodyType<LookupRequest> }

/**
 * @summary Find the patient in PF; a unique match starts the 15-minute patient session (P-03)
 */
export const useLookupPatient = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof lookupPatient>>,
      TError,
      LookupPatientMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof lookupPatient>>, TError, LookupPatientMutationVariables, TContext> => {
  return useMutation(getLookupPatientMutationOptions(options), queryClient)
}

export const getGetPublicOptionsUrl = (clinicSlug: string) => {
  return `/v1/public/clinics/${clinicSlug}/options`
}

/**
 * @summary Bookable locations, visit types, providers and their combinations; no PF call (P-07, P-17)
 */
export const getPublicOptions = async (
  clinicSlug: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<PublicOptions> => {
  return apiFetch<PublicOptions>(getGetPublicOptionsUrl(clinicSlug), {
    ...options,
    method: 'GET',

    schema: PublicOptions,
  })
}

export const getGetPublicOptionsQueryKey = (clinicSlug: string) => {
  return [`/v1/public/clinics/${clinicSlug}/options`] as const
}

export const getGetPublicOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicOptions>>,
  TError = ErrorType<ApiError>,
>(
  clinicSlug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicOptions>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPublicOptionsQueryKey(clinicSlug)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicOptions>>> = ({ signal }) =>
    getPublicOptions(clinicSlug, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: clinicSlug !== null && clinicSlug !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getPublicOptions>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetPublicOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicOptions>>>
export type GetPublicOptionsQueryError = ErrorType<ApiError>

export function useGetPublicOptions<TData = Awaited<ReturnType<typeof getPublicOptions>>, TError = ErrorType<ApiError>>(
  clinicSlug: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicOptions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicOptions>>,
          TError,
          Awaited<ReturnType<typeof getPublicOptions>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicOptions<TData = Awaited<ReturnType<typeof getPublicOptions>>, TError = ErrorType<ApiError>>(
  clinicSlug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicOptions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicOptions>>,
          TError,
          Awaited<ReturnType<typeof getPublicOptions>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicOptions<TData = Awaited<ReturnType<typeof getPublicOptions>>, TError = ErrorType<ApiError>>(
  clinicSlug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicOptions>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Bookable locations, visit types, providers and their combinations; no PF call (P-07, P-17)
 */

export function useGetPublicOptions<TData = Awaited<ReturnType<typeof getPublicOptions>>, TError = ErrorType<ApiError>>(
  clinicSlug: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicOptions>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPublicOptionsQueryOptions(clinicSlug, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getStartSessionUrl = (clinicSlug: string) => {
  return `/v1/public/clinics/${clinicSlug}/sessions`
}

/**
 * @summary Start a visit: the visit cookie and the source (P-00, P-01)
 */
export const startSession = async (
  clinicSlug: string,
  startSessionRequest?: StartSessionRequest,
  options?: Parameters<typeof apiFetch>[1],
): Promise<SessionStarted> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {}
    if (h instanceof Headers) return Object.fromEntries(h.entries())
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      )
    }
    const headers: Record<string, string | readonly string[]> = {}
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value
    }
    return headers
  }
  return apiFetch<SessionStarted>(getStartSessionUrl(clinicSlug), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startSessionRequest),
    schema: SessionStarted,
  })
}

export const getStartSessionMutationKey = () => ['startSession'] as const

export const getStartSessionMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startSession>>,
    TError,
    StartSessionMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof startSession>>, TError, StartSessionMutationVariables, TContext> => {
  const mutationKey = getStartSessionMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof startSession>>, StartSessionMutationVariables> = (
    props,
  ) => {
    const { clinicSlug, data } = props ?? {}

    return startSession(clinicSlug, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type StartSessionMutationResult = NonNullable<Awaited<ReturnType<typeof startSession>>>
export type StartSessionMutationBody = BodyType<StartSessionRequest> | undefined
export type StartSessionMutationError = ErrorType<ApiError>
export type StartSessionMutationVariables = { clinicSlug: string; data?: BodyType<StartSessionRequest> }

/**
 * @summary Start a visit: the visit cookie and the source (P-00, P-01)
 */
export const useStartSession = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startSession>>,
      TError,
      StartSessionMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof startSession>>, TError, StartSessionMutationVariables, TContext> => {
  return useMutation(getStartSessionMutationOptions(options), queryClient)
}

export const getEndSessionUrl = (clinicSlug: string) => {
  return `/v1/public/clinics/${clinicSlug}/sessions/current/end`
}

/**
 * @summary End the visit and expire both cookies; beacon-safe (P-00 close, page hide)
 */
export const endSession = async (clinicSlug: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {
  return apiFetch<void>(getEndSessionUrl(clinicSlug), {
    ...options,
    method: 'POST',
  })
}

export const getEndSessionMutationKey = () => ['endSession'] as const

export const getEndSessionMutationOptions = <TError = ErrorType<ApiError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof endSession>>, TError, EndSessionMutationVariables, TContext>
  request?: SecondParameter<typeof apiFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof endSession>>, TError, EndSessionMutationVariables, TContext> => {
  const mutationKey = getEndSessionMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof endSession>>, EndSessionMutationVariables> = (props) => {
    const { clinicSlug } = props ?? {}

    return endSession(clinicSlug, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type EndSessionMutationResult = NonNullable<Awaited<ReturnType<typeof endSession>>>

export type EndSessionMutationError = ErrorType<ApiError>
export type EndSessionMutationVariables = { clinicSlug: string }

/**
 * @summary End the visit and expire both cookies; beacon-safe (P-00 close, page hide)
 */
export const useEndSession = <TError = ErrorType<ApiError>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof endSession>>, TError, EndSessionMutationVariables, TContext>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof endSession>>, TError, EndSessionMutationVariables, TContext> => {
  return useMutation(getEndSessionMutationOptions(options), queryClient)
}

export const getGetEmbedOriginsUrl = () => {
  return `/v1/public/embed-origins`
}

/**
 * @summary Allowed embed origins per active clinic, for the patient build’s frame-ancestors (P-00, build time)
 */
export const getEmbedOrigins = async (options?: Parameters<typeof apiFetch>[1]): Promise<EmbedOrigins> => {
  return apiFetch<EmbedOrigins>(getGetEmbedOriginsUrl(), {
    ...options,
    method: 'GET',

    schema: EmbedOrigins,
  })
}

export const getGetEmbedOriginsQueryKey = () => {
  return [`/v1/public/embed-origins`] as const
}

export const getGetEmbedOriginsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmbedOrigins>>,
  TError = ErrorType<ApiError>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmbedOrigins>>, TError, TData>>
  request?: SecondParameter<typeof apiFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetEmbedOriginsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmbedOrigins>>> = ({ signal }) =>
    getEmbedOrigins({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmbedOrigins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmbedOriginsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmbedOrigins>>>
export type GetEmbedOriginsQueryError = ErrorType<ApiError>

export function useGetEmbedOrigins<TData = Awaited<ReturnType<typeof getEmbedOrigins>>, TError = ErrorType<ApiError>>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmbedOrigins>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmbedOrigins>>,
          TError,
          Awaited<ReturnType<typeof getEmbedOrigins>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmbedOrigins<TData = Awaited<ReturnType<typeof getEmbedOrigins>>, TError = ErrorType<ApiError>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmbedOrigins>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmbedOrigins>>,
          TError,
          Awaited<ReturnType<typeof getEmbedOrigins>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmbedOrigins<TData = Awaited<ReturnType<typeof getEmbedOrigins>>, TError = ErrorType<ApiError>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmbedOrigins>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Allowed embed origins per active clinic, for the patient build’s frame-ancestors (P-00, build time)
 */

export function useGetEmbedOrigins<TData = Awaited<ReturnType<typeof getEmbedOrigins>>, TError = ErrorType<ApiError>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmbedOrigins>>, TError, TData>>
    request?: SecondParameter<typeof apiFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmbedOriginsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
